import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import PropTypes from 'prop-types'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import autobind from 'autobind-decorator'
import baseURL from '../../../../../../../Root/url'

@withMutation(gql`
  mutation requestAuthenticationToken {
    token: requestAuthenticationToken {
      _id
      userId
      expiry
    }
  }
`)
@withMessage
export default class Download extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    document: PropTypes.object
  }

  state = {}

  @autobind
  async request() {
    this.setState({loading: true})
    try {
      const {token} = await this.props.requestAuthenticationToken()
      window.location.href = `${baseURL}/contracts/pdf/${this.props.document._id}/${token._id}`
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  render() {
    return (
      <div className={styles.container}>
        <Button primary onClick={this.request} loading={this.state.loading}>
          Descargar
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Ready/Title/Buttons/Download/index.js